@if (permisosIncidencias().w) {
    <div id="publicaciones" class="page-layout simple fullwidth" style="padding: 2rem">
        <div fxLayout="row wrap" class="p-12">
            @if (person(); as profilePerson) {
                <div
                    fxLayout="column"
                    fxLayoutAlign="center center"
                    fxFlex="3 1 0"
                    class="wrap-publicaciones p-12 w-100-p"
                >
                    <!-- Main Form Card -->
                    <div
                        class="fuse-card"
                        style="
                            background: white;
                            border-radius: 20px;
                            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
                            overflow: hidden;
                            border: none;
                            min-width: 80% !important;
                        "
                    >
                        <!-- User Profile Section -->
                        <div
                            class="new-restricted-form-header"
                            [class.new-restricted-form-header--solicitud]="isSolicitudModo"
                            style="padding: 2rem; color: white"
                        >
                            <div fxLayout="row" fxLayoutAlign="center center" style="gap: 1.5rem">
                                <div fxFlex="1 1 0" fxLayout="column" fxLayoutAlign="center start">
                                    <div fxLayout="row" fxLayoutAlign="start center" style="gap: 1.5rem">
                                        <div class="person-avatar" style="position: relative">
                                            <img
                                                class="img-circle"
                                                [src]="getImageUser(profilePerson.username)"
                                                style="
                                                    width: 80px;
                                                    height: 80px;
                                                    border: 4px solid rgba(255, 255, 255, 0.3);
                                                    border-radius: 50%;
                                                    object-fit: cover;
                                                "
                                            />
                                            <div
                                                style="
                                                    position: absolute;
                                                    bottom: 0;
                                                    right: 0;
                                                    width: 20px;
                                                    height: 20px;
                                                    background: #4caf50;
                                                    border-radius: 50%;
                                                    border: 3px solid white;
                                                "
                                            ></div>
                                        </div>
                                        <div fxLayout="column" fxLayoutAlign="start center">
                                            <h3 style="margin: 0; font-size: 1.5rem; font-weight: 500">
                                                {{ profilePerson.displayName }}
                                            </h3>
                                            @if (profilePerson.puestos.length != 0) {
                                                <p style="margin: 0.5rem 0 0 0; opacity: 0.9; font-size: 1rem">
                                                    {{ profilePerson.puestos[0].puesto }}
                                                </p>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div fxFlex="1 1 0" fxLayout="column" fxLayoutAlign="center center"></div>
                                <div fxFlex="1 1 0" fxLayout="column" fxLayoutAlign="center end">
                                    <div fxLayout="row" fxLayoutAlign="end center" style="gap: 1.5rem">
                                        <div fxLayout="column" fxLayoutAlign="end center">
                                            <h2 style="font-style: italic">
                                                @if (isSolicitudModo) {
                                                    Nueva solicitud
                                                } @else {
                                                    Registrar nuevo permiso
                                                }
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Form Content -->
                        <div style="padding: 1.5rem">
                            <!-- Error Messages -->
                            @for (err of errores; track err) {
                                <div fxLayout="column" fxLayoutAlign="center" style="margin-bottom: 0.75rem">
                                    <div
                                        style="
                                            background: #ffebee;
                                            border-left: 4px solid #f44336;
                                            padding: 0.75rem;
                                            border-radius: 8px;
                                            color: #c62828;
                                            font-weight: 500;
                                        "
                                    >
                                        <mat-icon style="vertical-align: middle; margin-right: 8px">error</mat-icon>
                                        {{ err }}
                                    </div>
                                </div>
                            }

                            <!-- Tipo de Incidencia Section -->
                            <div
                                fxLayout="column"
                                style="margin-bottom: 1.5rem"
                                [ngClass]="{ 'is-selectors-ok': isSelectorsOK }"
                            >
                                <div
                                    style="
                                        background: #f8f9fa;
                                        padding: 1rem;
                                        border-radius: 12px;
                                        border: 1px solid #e9ecef;
                                    "
                                >
                                    <div fxLayout="row" fxLayoutAlign="start center" style="gap: 1rem">
                                        <div fxFlex="1 1 0">
                                            <h4
                                                style="
                                                    margin: 0 0 0.75rem 0;
                                                    color: #2c3e50;
                                                    font-size: 1.1rem;
                                                    font-weight: 500;
                                                "
                                            >
                                                @if (isSelectorsOK) {
                                                    <mat-icon
                                                        style="vertical-align: middle; margin-right: 8px; color: green"
                                                        >check_circle</mat-icon
                                                    >
                                                    @if (isSolicitudModo) {
                                                        Tipo de Solicitud - Seleccionado correctamente
                                                    } @else {
                                                        Tipo de Permiso - Seleccionado correctamente
                                                    }
                                                } @else {
                                                    <mat-icon
                                                        style="
                                                            vertical-align: middle;
                                                            margin-right: 8px;
                                                            color: var(--feedbalia-color-navbar-500);
                                                        "
                                                        >category</mat-icon
                                                    >
                                                    @if (isSolicitudModo) {
                                                        Tipo de Solicitud - Seleccione el tipo de solicitud
                                                    } @else {
                                                        Tipo de Permiso - Seleccione el tipo de permiso y el subtipo si
                                                        es necesario
                                                    }
                                                }
                                            </h4>
                                        </div>
                                        <div fxFlex="1 1 0" fxLayoutAlign="end center">
                                            @if (tipoExxitaSeleccionadoData?.aditionalInfo) {
                                                <button
                                                    type="button"
                                                    class="tipo-incidencia-info-link"
                                                    (click)="abrirDialogInformacionTipoIncidencia()"
                                                >
                                                    @if (isSolicitudModo) {
                                                        Ver información sobre la solicitud
                                                    } @else {
                                                        Ver información sobre el permiso
                                                    }
                                                </button>
                                            }
                                        </div>
                                    </div>

                                    <div fxLayout="row" fxLayoutAlign="space-between" style="gap: 1rem">
                                        <div fxFlex="1 1 0">
                                            <label
                                                style="
                                                    display: block;
                                                    margin-bottom: 0.5rem;
                                                    color: #666;
                                                    font-weight: 500;
                                                "
                                                >Categoría Principal</label
                                            >
                                            <mat-form-field
                                                appearance="outline"
                                                style="width: 100%"
                                                class="compact-select"
                                            >
                                                <mat-select
                                                    [(value)]="agrupacionSeleccionada"
                                                    (selectionChange)="onAgrupacionChange()"
                                                    [disabled]="canSend"
                                                >
                                                    @for (option of agrupaciones(); track option.agrupacion) {
                                                        <mat-option [value]="option.agrupacion">{{
                                                            option.agrupacion
                                                        }}</mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div fxFlex="1 1 0">
                                            <label
                                                style="
                                                    display: block;
                                                    margin-bottom: 0.5rem;
                                                    color: #666;
                                                    font-weight: 500;
                                                "
                                                >Tipo</label
                                            >
                                            <mat-form-field
                                                appearance="outline"
                                                style="width: 100%"
                                                class="compact-select"
                                            >
                                                <mat-select
                                                    [(value)]="tipoExxitaSeleccionado"
                                                    (selectionChange)="onTipoIncidenciaChange()"
                                                    [disabled]="!canSelectTipoIncidencia() || canSend"
                                                >
                                                    @for (option of tiposIncidencias(); track option.id) {
                                                        <mat-option [value]="option.id">{{ option.tipo }}</mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        @if (muestraSelectorSubtipo) {
                                            <div fxFlex="1 1 0">
                                                <label
                                                    style="
                                                        display: block;
                                                        margin-bottom: 0.5rem;
                                                        color: #666;
                                                        font-weight: 500;
                                                    "
                                                    >Subtipo</label
                                                >
                                                <mat-form-field
                                                    appearance="outline"
                                                    style="width: 100%"
                                                    class="compact-select"
                                                >
                                                    <mat-select
                                                        [(value)]="subtipoExxitaSeleccionado"
                                                        (selectionChange)="onSubtipoIncidenciaChange()"
                                                        [disabled]="!tipoExxitaSeleccionado || canSend"
                                                    >
                                                        @for (option of subtiposDisponibles; track option.id) {
                                                            <mat-option [value]="option.id">{{
                                                                option.name
                                                            }}</mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>

                            @if (isSelectorsOK) {
                                <!-- Fechas Section -->

                                <div fxLayout="column" style="margin-bottom: 1.5rem">
                                    <h4
                                        style="
                                            margin: 0 0 0.75rem 0;
                                            color: #2c3e50;
                                            font-size: 1.1rem;
                                            font-weight: 500;
                                        "
                                    >
                                        <mat-icon
                                            style="
                                                vertical-align: middle;
                                                margin-right: 8px;
                                                color: var(--feedbalia-color-navbar-500);
                                            "
                                            >schedule</mat-icon
                                        >
                                        @if (isSolicitudModo) {
                                            Período de Solicitud
                                        } @else {
                                            Período de Permiso
                                        }
                                    </h4>
                                    <div
                                        style="
                                            background: #f8f9fa;
                                            padding: 1rem;
                                            border-radius: 12px;
                                            border: 1px solid #e9ecef;
                                        "
                                        [ngClass]="{ 'is-selectors-ok': comprobarFechas() }"
                                    >
                                        <div fxLayout="row" fxLayoutAlign="space-between" style="gap: 1rem">
                                            <div fxFlex="1 1 0">
                                                <label
                                                    style="
                                                        display: block;
                                                        margin-bottom: 0.5rem;
                                                        color: #666;
                                                        font-weight: 500;
                                                    "
                                                    >Fecha y Hora de Inicio</label
                                                >
                                                <input
                                                    style="
                                                        width: 100%;
                                                        padding: 12px;
                                                        border: 2px solid #e9ecef;
                                                        border-radius: 8px;
                                                        font-size: 1rem;
                                                        transition: border-color 0.3s;
                                                    "
                                                    class="datetime-picker"
                                                    type="datetime-local"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    placeholder="Inicio"
                                                    [(ngModel)]="fi"
                                                    autocomplete="off"
                                                    [disabled]="canSend"
                                                    [attr.min]="minFechaHoraConPreaviso"
                                                />
                                            </div>
                                            <div fxFlex="1 1 0">
                                                <label
                                                    style="
                                                        display: block;
                                                        margin-bottom: 0.5rem;
                                                        color: #666;
                                                        font-weight: 500;
                                                    "
                                                    >Fecha y Hora de Fin</label
                                                >
                                                <input
                                                    style="
                                                        width: 100%;
                                                        padding: 12px;
                                                        border: 2px solid #e9ecef;
                                                        border-radius: 8px;
                                                        font-size: 1rem;
                                                        transition: border-color 0.3s;
                                                    "
                                                    class="datetime-picker"
                                                    type="datetime-local"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    placeholder="Fin"
                                                    [(ngModel)]="ff"
                                                    autocomplete="off"
                                                    [disabled]="canSend"
                                                    [attr.min]="minFechaHoraConPreaviso"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                @if (comprobarFechas()) {
                                    @if (isCargandoDocumentos) {
                                        <div
                                            fxLayout="row"
                                            fxLayoutAlign="start center"
                                            style="gap: 0.75rem; margin-bottom: 1.5rem; color: #666"
                                        >
                                            <mat-spinner diameter="22"></mat-spinner>
                                            <span>Cargando documentación requerida…</span>
                                        </div>
                                    }
                                    @if (!isCargandoDocumentos) {
                                        <div fxLayout="column" style="margin-bottom: 1.5rem" class="doc-tipologia-wrap">
                                            @if (documentosTipologiaAnteriores.length > 0) {
                                                <h4
                                                    style="
                                                        margin: 0 0 0.5rem 0;
                                                        color: #2c3e50;
                                                        font-size: 1.1rem;
                                                        font-weight: 500;
                                                    "
                                                >
                                                    <mat-icon
                                                        style="
                                                            vertical-align: middle;
                                                            margin-right: 8px;
                                                            color: var(--feedbalia-color-navbar-500);
                                                        "
                                                        >attach_file</mat-icon
                                                    >
                                                    @if (isSolicitudModo) {
                                                        Documentación con la solicitud (antes de la solicitud)
                                                    } @else {
                                                        Documentación con el permiso (antes del permiso)
                                                    }
                                                </h4>
                                                <p class="doc-tipologia-intro">
                                                    Solo estos documentos se adjuntan ahora. Máximo 5 MB por archivo.
                                                    Los marcados como <strong>obligatorios</strong> deben subirse antes
                                                    @if (isSolicitudModo) {
                                                        de comprobar la solicitud
                                                    } @else {
                                                        de comprobar el permiso
                                                    }
                                                    .
                                                </p>
                                                <div
                                                    class="doc-tipologia-grid"
                                                    fxLayout="row wrap"
                                                    fxLayoutAlign="start stretch"
                                                    style="gap: 1rem; margin-bottom: 1.25rem; padding: 1rem"
                                                >
                                                    @for (doc of documentosTipologiaAnteriores; track doc.id) {
                                                        <div
                                                            class="doc-tipologia-card doc-tipologia-card--adjunto"
                                                            [class.doc-tipologia-card--required]="esDocObligatorio(doc)"
                                                            [class.doc-tipologia-card--optional]="
                                                                !esDocObligatorio(doc)
                                                            "
                                                            [class.doc-tipologia-card--attached]="!!getAdjunto(doc.id)"
                                                            fxFlex="1 1 260px"
                                                            fxLayout="column"
                                                            fxLayoutGap="0.4rem"
                                                        >
                                                            <div
                                                                class="doc-tipologia-card__watermark"
                                                                aria-hidden="true"
                                                            >
                                                                <mat-icon class="doc-tipologia-card__watermark-icon"
                                                                    >description</mat-icon
                                                                >
                                                            </div>
                                                            <div
                                                                fxLayout="row"
                                                                fxLayoutAlign="space-between center"
                                                                style="gap: 0.5rem"
                                                            >
                                                                @if (esDocObligatorio(doc)) {
                                                                    <span
                                                                        class="doc-badge doc-badge--required"
                                                                        [class.doc-badge--adjuntado]="
                                                                            !!getAdjunto(doc.id)
                                                                        "
                                                                        >Obligatorio</span
                                                                    >
                                                                } @else {
                                                                    <span
                                                                        class="doc-badge doc-badge--optional"
                                                                        [class.doc-badge--adjuntado]="
                                                                            !!getAdjunto(doc.id)
                                                                        "
                                                                        >Opcional</span
                                                                    >
                                                                }
                                                                @if (doc.aditionalInfo) {
                                                                    <mat-icon
                                                                        class="doc-tipologia-card__info-icon"
                                                                        [matTooltip]="doc.aditionalInfo"
                                                                        matTooltipClass="doc-tipologia-mat-tooltip"
                                                                        matTooltipShowDelay="200"
                                                                        tabindex="0"
                                                                        role="img"
                                                                        aria-label="Información adicional"
                                                                        >info_outline</mat-icon
                                                                    >
                                                                }
                                                            </div>
                                                            <div class="doc-tipologia-card__name-row">
                                                                <span class="doc-tipologia-card__title">{{
                                                                    doc.name || "Documento"
                                                                }}</span>
                                                            </div>
                                                            <input
                                                                #fileDocInput
                                                                type="file"
                                                                hidden
                                                                (change)="onAdjuntoTipologiaChange($event, doc)"
                                                            />
                                                            <div
                                                                class="doc-tipologia-card__footer"
                                                                fxLayout="column"
                                                                fxLayoutAlign="center center"
                                                                fxLayoutGap="0.5rem"
                                                            >
                                                                @if (!getAdjunto(doc.id)) {
                                                                    @if (doc.hadExample === 1) {
                                                                        <div
                                                                            class="doc-tipologia-card__btns-dual"
                                                                            fxLayout="row wrap"
                                                                            fxLayoutAlign="center center"
                                                                            fxLayoutGap="0.35rem"
                                                                        >
                                                                            <button
                                                                                mat-stroked-button
                                                                                type="button"
                                                                                color="primary"
                                                                                class="doc-tipologia-card__btn-adjuntar doc-tipologia-card__btn-adjuntar--compact doc-tipologia-card__btn-descarga-plantilla"
                                                                                matTooltip="Descargar plantilla de la solicitud"
                                                                                matTooltipShowDelay="200"
                                                                                (click)="descargarEjemploDocumento(doc)"
                                                                                [disabled]="
                                                                                    canSend || doc['bloqueadaDescarga']
                                                                                "
                                                                                style="
                                                                                    border: 1px solid rgb(14, 49, 115) !important;
                                                                                    color: rgb(14, 49, 115) !important;
                                                                                    background-color: rgba(
                                                                                        14,
                                                                                        49,
                                                                                        115,
                                                                                        0.09
                                                                                    ) !important;
                                                                                "
                                                                            >
                                                                                <mat-icon
                                                                                    style="
                                                                                        color: rgb(
                                                                                            14,
                                                                                            49,
                                                                                            115
                                                                                        ) !important;
                                                                                    "
                                                                                    class="doc-tipologia-card__btn-icon--compact doc-tipologia-card__btn-descarga-plantilla__icon"
                                                                                    >cloud_download</mat-icon
                                                                                >
                                                                                Descargar Plantilla
                                                                            </button>
                                                                            <button
                                                                                mat-stroked-button
                                                                                type="button"
                                                                                color="primary"
                                                                                class="doc-tipologia-card__btn-adjuntar doc-tipologia-card__btn-adjuntar--compact"
                                                                                (click)="fileDocInput.click()"
                                                                                [disabled]="canSend"
                                                                            >
                                                                                <mat-icon
                                                                                    class="doc-tipologia-card__btn-icon--compact"
                                                                                    >add</mat-icon
                                                                                >
                                                                                Adjuntar archivo
                                                                            </button>
                                                                        </div>
                                                                    } @else {
                                                                        <button
                                                                            mat-stroked-button
                                                                            type="button"
                                                                            color="primary"
                                                                            class="doc-tipologia-card__btn-adjuntar"
                                                                            (click)="fileDocInput.click()"
                                                                            [disabled]="canSend"
                                                                        >
                                                                            <mat-icon style="margin-right: 6px"
                                                                                >add</mat-icon
                                                                            >
                                                                            Adjuntar archivo
                                                                        </button>
                                                                    }
                                                                } @else {
                                                                    <div
                                                                        class="doc-tipologia-card__file doc-tipologia-card__fila-adjunto"
                                                                    >
                                                                        <mat-icon class="doc-tipologia-card__file-icon"
                                                                            >description</mat-icon
                                                                        >
                                                                        <span
                                                                            class="doc-tipologia-card__filename"
                                                                            [matTooltip]="
                                                                                getAdjunto(doc.id)!.displayName
                                                                            "
                                                                            >{{ getAdjunto(doc.id)!.displayName }}</span
                                                                        >
                                                                        <button
                                                                            mat-icon-button
                                                                            type="button"
                                                                            class="doc-tipologia-card__btn-quitar"
                                                                            aria-label="Quitar archivo"
                                                                            (click)="
                                                                                quitarAdjuntoTipologia(
                                                                                    doc.id,
                                                                                    fileDocInput
                                                                                )
                                                                            "
                                                                            [disabled]="canSend"
                                                                        >
                                                                            <mat-icon>close</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                }
                                                            </div>
                                                            @if (adjuntoErrorPorDocumentoId[doc.id]) {
                                                                <p class="doc-tipologia-card__error">
                                                                    {{ adjuntoErrorPorDocumentoId[doc.id] }}
                                                                </p>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }

                                            @if (muestraSeccionOtrosAdjuntos()) {
                                                <div class="incidencia-otros-adjuntos form-section">
                                                    <h4
                                                        style="
                                                            margin: 0 0 0.5rem 0;
                                                            color: #2c3e50;
                                                            font-size: 1.05rem;
                                                            font-weight: 500;
                                                        "
                                                    >
                                                        <mat-icon
                                                            style="
                                                                vertical-align: middle;
                                                                margin-right: 8px;
                                                                color: var(--feedbalia-color-navbar-500);
                                                            "
                                                            >folder_open</mat-icon
                                                        >
                                                        Otros documentos
                                                        <span class="incidencia-otros-adjuntos__optional"
                                                            >(Opcional)</span
                                                        >
                                                    </h4>
                                                    <p class="doc-tipologia-intro" style="margin-bottom: 0.65rem">
                                                        Puedes adjuntar hasta
                                                        <strong>{{ maxOtrosAdjuntosPermitidos }}</strong> archivos
                                                        adicionales. Cada uno como máximo <strong>5 MB</strong>. Tipos
                                                        habituales: imagen, vídeo, audio o PDF.
                                                    </p>
                                                    <div class="file-upload-container">
                                                        <input
                                                            type="file"
                                                            id="fileInputIncidenciaOtros"
                                                            class="file-input"
                                                            (change)="onOtrosAdjuntosSelected($event)"
                                                            multiple
                                                            accept="image/*,video/*,audio/*,.pdf"
                                                            [disabled]="!puedeAnadirMasOtrosAdjuntos()"
                                                        />
                                                        <label
                                                            for="fileInputIncidenciaOtros"
                                                            class="file-input-label"
                                                            [class.file-input-label--disabled]="
                                                                !puedeAnadirMasOtrosAdjuntos()
                                                            "
                                                        >
                                                            <span class="file-input-icon">📎</span>
                                                            <span class="file-input-text"
                                                                >Añadir archivos (máx.
                                                                {{ maxOtrosAdjuntosPermitidos }} · 5 MB c/u)</span
                                                            >
                                                        </label>
                                                    </div>
                                                    @if (otrosAdjuntosError) {
                                                        <span class="incidencia-otros-adjuntos__error">{{
                                                            otrosAdjuntosError
                                                        }}</span>
                                                    }
                                                    @if (otrosAdjuntosItems.length > 0) {
                                                        <div class="selected-files-list">
                                                            <div class="selected-files-header">
                                                                <span
                                                                    >Archivos adicionales ({{
                                                                        otrosAdjuntosItems.length
                                                                    }}/{{ maxOtrosAdjuntosPermitidos }}) —
                                                                    {{
                                                                        formatOtroFileSize(getTotalOtrosAdjuntosSize())
                                                                    }}</span
                                                                >
                                                            </div>
                                                            @for (item of otrosAdjuntosItems; track $index) {
                                                                <div class="selected-file-item">
                                                                    <div class="file-item-header">
                                                                        <span class="file-icon">{{
                                                                            getOtroFileIcon(item.file)
                                                                        }}</span>
                                                                        <span class="file-name">{{
                                                                            item.file.name
                                                                        }}</span>
                                                                        <span class="file-size"
                                                                            >({{
                                                                                formatOtroFileSize(item.file.size)
                                                                            }})</span
                                                                        >
                                                                        <button
                                                                            type="button"
                                                                            class="file-remove-btn"
                                                                            (click)="removeOtroAdjunto($index)"
                                                                            [disabled]="canSend"
                                                                            title="Eliminar archivo"
                                                                        >
                                                                            ✕
                                                                        </button>
                                                                    </div>
                                                                    <div class="file-meta-row">
                                                                        <div class="file-meta-field">
                                                                            <label class="file-meta-label">
                                                                                Nombre del documento
                                                                                <span class="file-meta-chars"
                                                                                    >({{
                                                                                        item.nombreDocumento?.length ??
                                                                                            0
                                                                                    }}
                                                                                    /
                                                                                    {{
                                                                                        maxNombreDocumentoOtrosLength
                                                                                    }})</span
                                                                                >
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                class="file-meta-input"
                                                                                [attr.name]="'nombreOtros_' + $index"
                                                                                [(ngModel)]="item.nombreDocumento"
                                                                                [ngModelOptions]="{ standalone: true }"
                                                                                [maxlength]="
                                                                                    maxNombreDocumentoOtrosLength
                                                                                "
                                                                                placeholder="Nombre para identificar el archivo"
                                                                                [disabled]="canSend"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }

                                            @if (documentosTipologiaPosteriores.length > 0) {
                                                <h4
                                                    class="doc-tipologia-posteriores-title"
                                                    style="
                                                        margin: 0 0 0.5rem 0;
                                                        color: #546e7a;
                                                        font-size: 1rem;
                                                        font-weight: 500;
                                                    "
                                                >
                                                    <mat-icon
                                                        style="
                                                            vertical-align: middle;
                                                            margin-right: 8px;
                                                            color: #78909c;
                                                        "
                                                        >info_outline</mat-icon
                                                    >
                                                    Documentación posterior (solo informativo)
                                                </h4>
                                                <p class="doc-tipologia-intro doc-tipologia-intro--muted">
                                                    Estos documentos deberán adjuntarse en un momento posterior a la
                                                    solicitud .
                                                </p>
                                                <div
                                                    class="doc-tipologia-grid"
                                                    fxLayout="row wrap"
                                                    fxLayoutAlign="start stretch"
                                                    style="gap: 1rem; padding: 1rem"
                                                >
                                                    @for (doc of documentosTipologiaPosteriores; track doc.id) {
                                                        <div
                                                            class="doc-tipologia-card doc-tipologia-card--solo-info"
                                                            fxFlex="1 1 260px"
                                                            fxLayout="column"
                                                            fxLayoutGap="0.35rem"
                                                        >
                                                            <div
                                                                fxLayout="row"
                                                                fxLayoutAlign="space-between start"
                                                                style="gap: 0.5rem"
                                                            >
                                                                <span class="doc-tipologia-card__title">{{
                                                                    doc.name || "Documento"
                                                                }}</span>
                                                                @if (esDocObligatorio(doc)) {
                                                                    <span class="doc-badge doc-badge--info-required"
                                                                        >Oblig. (después)</span
                                                                    >
                                                                } @else {
                                                                    <span class="doc-badge doc-badge--info-optional"
                                                                        >Opcional</span
                                                                    >
                                                                }
                                                            </div>
                                                            <span class="doc-prepost-chip doc-prepost-chip--muted">
                                                                @if (isSolicitudModo) {
                                                                    Después de la solicitud
                                                                } @else {
                                                                    Después de la incidencia
                                                                }
                                                            </span>
                                                            @if (doc.aditionalInfo) {
                                                                <p class="doc-tipologia-card__info">
                                                                    {{ doc.aditionalInfo }}
                                                                </p>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }

                                    <!-- Motivo Section -->
                                    <div fxLayout="column" style="margin-bottom: 1.5rem">
                                        <h4
                                            style="
                                                margin: 0 0 0.75rem 0;
                                                color: #2c3e50;
                                                font-size: 1.1rem;
                                                font-weight: 500;
                                            "
                                        >
                                            <mat-icon
                                                style="
                                                    vertical-align: middle;
                                                    margin-right: 8px;
                                                    color: var(--feedbalia-color-navbar-500);
                                                "
                                                >description</mat-icon
                                            >
                                            {{ "vacaciones_incidencias.incidencia.motivo" | translate }}
                                        </h4>
                                        <mat-form-field appearance="outline" style="width: 100%">
                                            <input
                                                matInput
                                                placeholder="Describe el motivo de la solicitud..."
                                                [(ngModel)]="motivo"
                                                style="font-size: 1rem"
                                                [disabled]="canSend"
                                            />
                                        </mat-form-field>
                                    </div>
                                    <!-- Submit Button Section -->

                                    <div fxLayout="column" fxLayoutAlign="center center" style="margin-top: 1.5rem">
                                        <div>
                                            @if (!comprobacionEnviada) {
                                                <button
                                                    mat-raised-button
                                                    style="
                                                        background: linear-gradient(
                                                            135deg,
                                                            var(--feedbalia-color-navbar-500) 0%,
                                                            var(--feedbalia-color-navbar-700) 100%
                                                        );
                                                        color: white;
                                                        padding: 1rem 3rem;
                                                        font-size: 1.1rem;
                                                        border-radius: 50px;
                                                        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
                                                        border: none;
                                                    "
                                                    (click)="comprobarIncidencias()"
                                                    [disabled]="!validarDatosExxita() || isCheckingAvailability"
                                                >
                                                    @if (isCheckingAvailability) {
                                                        <mat-spinner
                                                            diameter="20"
                                                            style="margin-right: 8px"
                                                        ></mat-spinner>
                                                    }
                                                    @if (!isCheckingAvailability) {
                                                        <mat-icon style="margin-right: 8px">search</mat-icon>
                                                    }
                                                    {{
                                                        isCheckingAvailability
                                                            ? "Comprobando..."
                                                            : "Comprobar disponibilidad"
                                                    }}
                                                </button>
                                            } @else {
                                                @if (canSend) {
                                                    <!-- Success Message -->
                                                    <div
                                                        fxLayout="column"
                                                        fxLayoutAlign="center center"
                                                        style="margin-bottom: 1rem"
                                                    >
                                                        <div
                                                            style="
                                                                background: #e8f5e8;
                                                                border-left: 4px solid #4caf50;
                                                                padding: 0.75rem;
                                                                border-radius: 8px;
                                                                color: #2e7d32;
                                                                font-weight: 500;
                                                            "
                                                        >
                                                            <mat-icon style="vertical-align: middle; margin-right: 8px"
                                                                >check_circle</mat-icon
                                                            >
                                                            @if (isSolicitudModo) {
                                                                Solicitud correcta, puede enviarla
                                                            } @else {
                                                                Solicitud de incidencia correcta, puede enviarla
                                                            }
                                                        </div>
                                                    </div>
                                                    <!-- Action Buttons -->
                                                    <div
                                                        fxLayout="row"
                                                        fxLayoutAlign="center center"
                                                        fxLayoutGap="1rem"
                                                    >
                                                        <button
                                                            mat-stroked-button
                                                            style="
                                                                border: 2px solid #f44336;
                                                                color: #f44336;
                                                                padding: 1rem 2rem;
                                                                font-size: 1.1rem;
                                                                border-radius: 50px;
                                                            "
                                                            (click)="cancelarComprobacion()"
                                                        >
                                                            <mat-icon style="margin-right: 8px">cancel</mat-icon>
                                                            Cancelar
                                                        </button>
                                                        <button
                                                            mat-raised-button
                                                            style="
                                                                background: linear-gradient(
                                                                    135deg,
                                                                    var(--feedbalia-color-navbar-500) 0%,
                                                                    var(--feedbalia-color-navbar-700) 100%
                                                                );
                                                                color: white;
                                                                padding: 1rem 3rem;
                                                                font-size: 1.1rem;
                                                                border-radius: 50px;
                                                                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
                                                                border: none;
                                                            "
                                                            (click)="send()"
                                                            [disabled]="!validarDatosExxita() || isSending"
                                                        >
                                                            @if (isSending) {
                                                                <mat-spinner
                                                                    diameter="20"
                                                                    style="margin-right: 8px"
                                                                ></mat-spinner>
                                                            }
                                                            @if (!isSending) {
                                                                <mat-icon style="margin-right: 8px">send</mat-icon>
                                                            }
                                                            {{
                                                                isSending
                                                                    ? "Enviando..."
                                                                    : ("vacaciones_incidencias.incidencia.send"
                                                                      | translate)
                                                            }}
                                                        </button>
                                                    </div>
                                                } @else {
                                                    <!-- Error Messages from Validation -->
                                                    @for (err of erroresComprobado; track err) {
                                                        <div
                                                            fxLayout="column"
                                                            fxLayoutAlign="center"
                                                            style="margin-bottom: 0.75rem"
                                                        >
                                                            <div
                                                                style="
                                                                    background: #ffebee;
                                                                    border-left: 4px solid #f44336;
                                                                    padding: 0.75rem;
                                                                    border-radius: 8px;
                                                                    color: #c62828;
                                                                    font-weight: 500;
                                                                "
                                                            >
                                                                <mat-icon
                                                                    style="vertical-align: middle; margin-right: 8px"
                                                                    >error</mat-icon
                                                                >
                                                                {{ err }}
                                                            </div>
                                                        </div>
                                                    }
                                                    <!-- Action Buttons -->
                                                    <div
                                                        fxLayout="row"
                                                        fxLayoutAlign="center center"
                                                        fxLayoutGap="1rem"
                                                    >
                                                        <button
                                                            mat-raised-button
                                                            style="
                                                                background: linear-gradient(
                                                                    135deg,
                                                                    var(--feedbalia-color-navbar-500) 0%,
                                                                    var(--feedbalia-color-navbar-700) 100%
                                                                );
                                                                color: white;
                                                                padding: 1rem 3rem;
                                                                font-size: 1.1rem;
                                                                border-radius: 50px;
                                                                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
                                                                border: none;
                                                            "
                                                            (click)="comprobarIncidencias()"
                                                            [disabled]="!validarDatosExxita() || isCheckingAvailability"
                                                        >
                                                            @if (isCheckingAvailability) {
                                                                <mat-spinner
                                                                    diameter="20"
                                                                    style="margin-right: 8px"
                                                                ></mat-spinner>
                                                            }
                                                            @if (!isCheckingAvailability) {
                                                                <mat-icon style="margin-right: 8px">refresh</mat-icon>
                                                            }
                                                            {{
                                                                isCheckingAvailability
                                                                    ? "Comprobando..."
                                                                    : "Volver a comprobar"
                                                            }}
                                                        </button>
                                                    </div>
                                                }
                                            }
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
}
